const LEAGUE_PREFIX = "mpg_league_";
const DIVISION_PREFIX = "mpg_division_";
const MATCH_PREFIX = "mpg_division_match_";

/**
 * Renvoi l'identifiant de division d'une ligue
 * Le divisionId n'est pas toujours fourni : il se déduit alors de l'identifiant de ligue.
 * Ce repli (hérité de BestTeamDisplay) est au mieux approximatif : un leagueId ne porte
 * pas le suffixe de division (ex. mpg_league_RVUGWFH6_3 donne mpg_division_RVUGWFH6_3,
 * sans le numéro de division). Un futur lecteur ne devrait pas s'y fier.
 * @param {Object} league la ligue issue des données live
 * @returns {String|undefined} l'identifiant de division
 */
const getDivisionId = (league) => {
  if (league.divisionId) {
    return league.divisionId;
  }
  const leagueId = league.leagueId || league.id;
  if (! leagueId?.startsWith(LEAGUE_PREFIX)) {
    return undefined;
  }
  return leagueId.replace(LEAGUE_PREFIX, DIVISION_PREFIX);
};

/**
 * Renvoi le numéro de la journée à venir en le déduisant d'un identifiant de match
 * Format : mpg_division_match_{code division}_{journée}_{...}
 * @param {String} matchId l'identifiant d'un match de la journée à venir
 * @param {String} divisionId l'identifiant de division
 * @returns {Number|undefined} le numéro de journée
 */
const extractGameWeek = (matchId, divisionId) => {
  if (! matchId || ! divisionId) {
    return undefined;
  }
  const divisionCode = divisionId.replace(DIVISION_PREFIX, "");
  const gameWeek = Number(matchId.replace(`${MATCH_PREFIX}${divisionCode}_`, "").split("_")[0]);
  return Number.isNaN(gameWeek) ? undefined : gameWeek;
};

/**
 * Renvoi le numéro de la dernière journée jouée d'une ligue
 * @param {Object} league la ligue issue des données live
 * @returns {Number|undefined} le numéro de journée, undefined en début de saison
 */
const getLastPlayedGameWeek = (league) => {
  const nextGameWeek = league.nextDivisionGameWeek?.gameWeek
    || extractGameWeek(league.nextDivisionGameWeek?.matchesIds?.[0], getDivisionId(league));

  if (! nextGameWeek || nextGameWeek <= 1) {
    return undefined;
  }
  return nextGameWeek - 1;
};

export { getDivisionId, getLastPlayedGameWeek };